import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { CookieService } from "angular2-cookie/core";
import { GlobalsService } from '../common/services/globals.service';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Router} from '@angular/router';

@Component({
  selector: 'app-payload-simulator',
  templateUrl: './payload-simulator.component.html',
  styleUrls: ['./payload-simulator.component.css']
})
export class PayloadSimulatorComponent implements OnInit {

  simulationParam = '';
  payloadValue = '';
  decodedPayLoadValue = '';
  //simulatorDataObject:Object = {}

  constructor(
    private _global: GlobalsService,
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private cookieService: CookieService
    ) { }

  get partner(){
    return GlobalsService.partner;
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.simulationParam = params['simulation'];
    });
  }

  // user hits the sumbit button, set the simulated cookie
  submit() {
    this.decodedPayLoadValue = btoa(this.payloadValue);
    //this.simulatorDataObject['decodedPayLoadValue'] = this.decodedPayLoadValue;
    //this.simulatorDataObject['simulatedStatus'] = true;
    this.cookieService.put( 'simulator_cookie', this.decodedPayLoadValue );
    this.cookieService.put( 'simulator_cookie_status', 'true' );
    window.location.href = '/billing/paynow/?partner=' + this.partner;
  }
}
